export * from './core';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/core/index.js
// module id = 285
// module chunks = 0